<template>
  <div class="button-container">
    <button
      v-for="(button, index) of options"
      :key="button.label ? button.label : button"
      :class="buttonClasses(button, index)"
      @hover="alert('hi')"
      @click.prevent="chooseButton(button)"
      @mouseenter="onHover(index)"
      @mouseleave="onHover(index)"
    >
    <span :class="iconClasses(button, index)" v-html="button.icon ? button.icon : ''"></span>
    {{ button.label ? button.label : button }}
    </button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      hoveredButtons: {}
    }
  },
  methods: {
    buttonClasses (button, index) {
      const classes = []
      if (button.icon) {
        classes.push('icon')
      } else {
        if (this.isSelected(button) || this.hoveredButtons[index]) {
          classes.push('bg-color-2', 'color-1', 'active')
        } else {
          classes.push('color-2')
        }
      }

      return classes.join(' ')
    },
    onHover (index) {
      this.$set(this.hoveredButtons, index, !this.hoveredButtons[index])
    },
    iconClasses (button, index) {
      const classes = []
      if (this.isSelected(button) || this.hoveredButtons[index]) {
        classes.push('bg-color-2', 'color-1')
      } else {
        classes.push('color-2')
      }
      return classes.join(' ')
    },
    isSelected (button) {
      if (button.label == null) {
        return button === this.value
      } else {
        return button.label === this.value
      }
    },
    chooseButton (button) {
      this.$emit('input', { value: button.label ? button.label : button, nextRoutePath: button.nextRoutePath })
    }
  },
  props: ['options', 'value']
}
</script>
